import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";
import { inspirations } from "@/mocks/inspirations";
import { INSTAGRAM_URL } from "@/mocks/navigation";
import { useSiteText } from "@/lib/siteContent";

export default function Inspirations() {
  const title = useSiteText("inspirations.title", "Inspirações Auréa");
  return (
    <section className="w-full bg-background-50" aria-label="Inspirações Auréa">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-7xl">
          <SectionHeading
            eyebrow="Mural de inspirações"
            title={title}
            text="Detalhes de sandálias, tênis urbanos, bolsas e semijoias que mostram o jeito Auréa de montar cada look."
          />

          <div className="mt-12 grid auto-rows-[170px] grid-cols-2 gap-3 md:auto-rows-[210px] lg:grid-cols-4">
            {inspirations.map((item, index) => (
              <Reveal
                key={item.id}
                delay={(index % 4) * 70}
                className={item.tall ? "row-span-2" : "row-span-1"}
              >
                <figure className="group relative h-full w-full overflow-hidden rounded-lg bg-background-200">
                  <img
                    src={item.image}
                    alt={`Inspiração Auréa — ${item.label}`}
                    title={`Inspiração Auréa — ${item.label}`}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <figcaption className="absolute inset-0 flex items-end bg-gradient-to-t from-foreground-950/75 via-transparent to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    <span className="text-xs font-medium uppercase tracking-[0.16em] text-background-50">
                      {item.label}
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-10 flex justify-center">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-primary-50 px-7 py-3.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
            >
              <i className="ri-instagram-line text-lg" />
              Acompanhar novidades
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}